// extracted by mini-css-extract-plugin
module.exports = {"label":"LoadSpecView_label__34LBg","load-spec":"LoadSpecView_load-spec__3SZje"};